import React, { useContext, useState } from "react";
import { Stack, GTIWebTextField, GTIWebButton, Divider, Link } from "@gti-controls-v2/web-core";
import { useTranslation } from "../../../hooks/useTranslation";
import { paths } from "../../../common/constants/Rutas";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../providers/auth";
import { DialogoAcercaDe } from "./DialogoAcercaDe";

export const PopoverUsuario = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const [isShowingDialogo, setIsShowingDialogo] = useState(false);

  const onLogout = () => {
    try{
      logout();
      navigate(paths.Login);
    }catch(e){
      console.error(e);
    }
  }
  
  return (
    <Stack style={{ padding: 20 }} width="100%" spacing={2}>
      <GTIWebTextField
        labelText={t("sistema.usuarios.singular")}
        value={user?.usuarioNombre}
        readOnly
      />
      {/* <GTIWebTextField
        labelText={t("sistema.usuarios.correo")}
        value={"ivan@gmail.com"}
        readOnly
      /> */}
      <GTIWebButton
        id={"Button_Usuario_Cerrar_Sesion"}
        text={t("sistema.acciones.cerrarSesion")}
        onClick={onLogout}
      />
      <Divider />
      <Link component="button" variant="body2" onClick={ () => { setIsShowingDialogo(true)} }>
        {t("sistema.titulos.acercaDe")}
      </Link>
      <DialogoAcercaDe isShowingDialogo={isShowingDialogo} setIsShowingDialogo={setIsShowingDialogo} />
    </Stack>
  );
};

export default PopoverUsuario;
